(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var database;

exports.open = function(callback) {
  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

  var DBOpenRequest = indexedDB.open("DonutClicker", 1);

  DBOpenRequest.onupgradeneeded = function(e) {
    console.log('[IndexedDB] Database upgrade.');
    database = e.target.result;
    if (!database.objectStoreNames.contains("clickerStore")) {
      var objectStore = database.createObjectStore("clickerStore", {
        keyPath: "key"
      });
      objectStore.createIndex("key", "key", {
        unique: true
      });
    }

  };

  DBOpenRequest.onsuccess = function(e) {
    console.log('[IndexedDB] Database initialised.');
    database = e.target.result;
    database.onerror = function(e) {
      console.error("[IndexedDB] error: " + e.target.errorCode);
    };
    if (callback)
      callback();
  };

  DBOpenRequest.onerror = function(e) {
    console.error('[IndexedDB] Opening error.');
  };
};

exports.save = function(key, value) {
  if (database) {
    var tx = database.transaction(["clickerStore"], "readwrite");
    var store = tx.objectStore('clickerStore');
    var request = store.put({
      key,
      value
    });
    request.onerror = function(e) {
      console.error('[IndexedDB] Error: ' + e);
    };
  } else {
    console.error('Open database at first');
    return false;
  }
};

exports.load = function(callback) {
  if (database) {
    var tx = database.transaction(["clickerStore"], "readonly");
    var store = tx.objectStore("clickerStore");
    var request = store.getAll();
    request.onsuccess = function(e) {
      callback(request.result);
    };
  } else {
    console.error('Open database at first');
    return false;
  }
};

// var closeDatabase = function() {
//   database.close();
//   database = null;
// };

},{}],2:[function(require,module,exports){
var Donut = function(options) {
  this.money = options.money || 0;
  this.clicks = options.clicks || 0;
}

module.exports = Donut;

},{}],3:[function(require,module,exports){
require('./donut');
const Upgrade = require('./upgrade');
const Database = require('./database');

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('Service-Worker.js').then(function(registration) {
      // Registration was successful
      console.log('ServiceWorker registration successful with scope:', registration.scope);
    }, function(err) {
      // registration failed :(
      console.log('ServiceWorker registration failed: ', err);
    });
  });
}

const clickerModule = (function() {

  // DOM
  var $donut = document.querySelector('#donut'),
    $clicks = document.querySelector('#clicks'),
    $money = document.querySelector('#money');

  // Variables
  var money = 0,
    clicks = 0,
    moneyOnClick = 1,
    moneyPerTime = 1,
    moneyEveryTime = 300 * 1000,
    database;

  // Methods
  var countClick = function() {
    clicks++;
    $clicks.innerHTML = clicks;
    Database.save('clicks', clicks);
  };

  var clickMoney = function() {
    updateMoney(money + moneyOnClick);

  };

  var timeMoney = function() {
    updateMoney(money + moneyPerTime);
    setTimeout(timeMoney, moneyEveryTime);
  };

  var updateMoney = function(value) {
    money = value;
    $money.innerHTML = value;
    Database.save('money', value);
  };

  // Creating Objects
  var clickUpgrade = new Upgrade({
    requiredMoney: 20,
    obtainedMoney: 1,
    moneyMultiplier: 3,
    upgradeMultiplier: 2,
    btnElement: document.querySelector('#clickUpgrade'),
    donutElement: document.querySelectorAll('.donut__topping')
  });

  var moneyEveryTimeUpgrade = new Upgrade({
    requiredMoney: 100,
    obtainedMoney: 300,
    moneyMultiplier: 2,
    upgradeMultiplier: 0.98,
    btnElement: document.querySelector('#timeUpgrade'),
    statElement: document.querySelector('#moneyEveryTime'),
    donutElement: document.querySelectorAll('.donut__frostig')
  });

  var moneyPerTimeUpgrade = new Upgrade({
    requiredMoney: 50,
    obtainedMoney: 1,
    moneyMultiplier: 2.25,
    upgradeMultiplier: 2,
    btnElement: document.querySelector('#moneyTimeUpgrade'),
    statElement: document.querySelector('#moneyPerTime'),
    donutElement: document.querySelectorAll('.donut__cake')
  });

  // Event Handlers
  var handleEvents = function() {
    $donut.addEventListener('click', function() {
      countClick();
      clickMoney();
    });

    $donut.addEventListener('mousedown', function(e) {
      e.preventDefault();
    }, false);

    clickUpgrade.btn.addEventListener('click', function() {
      let results = clickUpgrade.boost(money);

      if (results) {
        updateMoney(results.newMoney);
        moneyOnClick = results.newUpgrade;
        Database.save('moneyOnClick', {
          color: clickUpgrade.eC,
          level: clickUpgrade.level
        });
      }
    });

    moneyEveryTimeUpgrade.btn.addEventListener('click', function() {
      let results = moneyEveryTimeUpgrade.boost(money);
      if (results) {
        moneyEveryTime = results.newUpgrade * 1000;
        window.clearTimeout(timeMoney);
        setTimeout(timeMoney, moneyEveryTime);
        updateMoney(results.newMoney);
        Database.save('moneyEveryTime', {
          color: moneyEveryTimeUpgrade.eC,
          level: moneyEveryTimeUpgrade.level
        });
      }
    });

    moneyPerTimeUpgrade.btn.addEventListener('click', function() {
      let results = moneyPerTimeUpgrade.boost(money);
      if (results) {
        updateMoney(results.newMoney);
        moneyPerTime = results.newUpgrade;
        Database.save('moneyPerTime', {
          color: moneyPerTimeUpgrade.eC,
          level: moneyPerTimeUpgrade.level
        });
      }
    });
  };

  // Sets stats
  var setStats = function(stats) {
    for (let stat of stats) {
      if (typeof stat.value !== 'object' && stat.value.constructor !== Object) {
        eval(`${stat.key} = ${stat.value}`);
      } else {
        switch (stat.key) {
          case 'moneyPerTime':
            moneyPerTime = moneyPerTimeUpgrade.load(stat.value);
            break;
          case 'moneyEveryTime':
            moneyEveryTime = moneyEveryTimeUpgrade.load(stat.value) * 1000;
            break;
          case 'moneyOnClick':
            moneyOnClick = clickUpgrade.load(stat.value);
            break;

        }
      }
    }
    document.querySelector('#moneyEveryTime').innerHTML = moneyEveryTime / 1000;
    document.querySelector('#moneyPerTime').innerHTML = moneyPerTime;
    $clicks.innerHTML = clicks;
    $money.innerHTML = money;

  };

  // Sets intervals up
  var setIntervals = function() {
    setTimeout(timeMoney, moneyEveryTime);
    setInterval(function() {
      clickUpgrade.checkUpgradeAvailable(money);
    }, 200);
    setInterval(function() {
      moneyEveryTimeUpgrade.checkUpgradeAvailable(money);
    }, 200);
    setInterval(function() {
      moneyPerTimeUpgrade.checkUpgradeAvailable(money);
    }, 200);
  };

  // Init
  var init = function() {
    handleEvents();
    Database.open(function() {
      Database.load(setStats);
      setIntervals();
    });
  }();
})();

},{"./database":1,"./donut":2,"./upgrade":5}],4:[function(require,module,exports){
var getRandomColor = () => {
  let letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

module.exports = getRandomColor;

},{}],5:[function(require,module,exports){
const getRandomColor = require('./randomColor');

// CONSTRUCTOR
var Upgrade = function(options) {
  this.level = 1;
  this.btn = options.btnElement;
  this.rM = options.requiredMoney;
  this.mM = options.moneyMultiplier;
  this.oM = options.obtainedMoney;
  this.uM = options.upgradeMultiplier;
  this.dE = options.donutElement;
  this.eC = options.color || getRandomColor();
  if (options.hasOwnProperty('statElement')) {
    this.sE = options.statElement;
  }
};

// METHODS
Upgrade.prototype.boost = function(money) {
  
  if (money < this.rM) {
    console.log(this.oM * this.uM);
    return false;
  } else {
    this.level++;
    this.btn.previousElementSibling.children[1].innerHTML = this.level;
    this.checkUpgradeAvailable();
    let newMoney = parseInt(money - this.rM);
    this.rM = this.rM * this.mM;
    this.oM = parseInt(this.oM * this.uM);
    if (this.hasOwnProperty('sE')) {
      this.sE.innerHTML = this.oM;
    }
    this.setColor(getRandomColor());
    return {
      newMoney,
      newUpgrade: this.oM
    };
  }
};

Upgrade.prototype.setColor = function(color) {
  this.eC = color;
  this.dE.forEach((item) => {
    item.style.fill = this.eC;
  });
};

Upgrade.prototype.checkUpgradeAvailable = function(money) {
  if (this.rM <= money) {
    this.btn.parentElement.classList.remove('disabled');
  } else {
    this.btn.parentElement.classList.add('disabled');
  }
};

Upgrade.prototype.load = function({
  level,
  color
}) {
  if (level) {
    while (this.level != level) {
      this.boost(9999999999999);
    }
    if (color) {
      this.setColor(color);
    }
    return parseInt(this.oM);
  }

};

module.exports = Upgrade;

},{"./randomColor":4}]},{},[3])